import { Component } from '@angular/core';

@Component({
    selector: 'app-query-product-page',
    templateUrl: './query-product.component.html',
})
export class QueryProductPageComponent {}
